import Vue from 'vue'
import Vuex from 'vuex'
import { tdApi } from "@/services/td/td.api.service";
import { INode } from "@/shared/models/node.model";
import { ResponsibilityType } from '@/shared/enums/responsibilitytype.enum';
import { CookieHelper } from '@/shared/lib/cookiehelper';

Vue.use(Vuex)

export interface ICartItem {
  Id: number;
  Path: string;
  Url: string;
  Data: any;
}

export default new Vuex.Store({
  state: {
    isTdAdmin: false as boolean,
    tree: [] as INode[],
    cart: [] as ICartItem[],
    filter: [] as ResponsibilityType[],
  },
  getters: {

  },
  mutations: {
    SET_ISTDADMIN(state, isTdAdmin) {
      state.isTdAdmin = isTdAdmin;
    },
    SET_TREE(state, tree) {
      state.tree = tree;
      localStorage.setItem("tree", JSON.stringify(tree));
    },
    SET_CART(state, newCart) {
      state.cart = newCart;
      localStorage.setItem("guideline-cart", JSON.stringify(newCart));
    },
    SET_FILTER(state, newFilter) {
      state.filter = newFilter;
      localStorage.setItem("guideline-filter", JSON.stringify(newFilter));
    }
  },
  actions: {
    setIsTdAdmin() {
      const helper = new CookieHelper();
      this.commit("SET_ISTDADMIN", helper.validateTdCookie());
    },
    async setTree() {
      const treeVal = localStorage.getItem("guideline-tree");
      const cacheTimeVal = localStorage.getItem("guideline-cache-time") ?? "2300-01-01T00:00:00:000Z"
      const cacheTime = new Date(cacheTimeVal);
      const expiryDate = new Date(new Date().setMinutes(new Date().getMinutes() - 60*24));
      if (!treeVal || cacheTime < expiryDate) {
        const tree = await tdApi.getTree();
        this.commit("SET_TREE", tree);
        localStorage.setItem("guideline-tree", JSON.stringify(tree));
        localStorage.setItem("guideline-cache-time", new Date().toISOString());
      }
      else {
        this.commit("SET_TREE", JSON.parse(treeVal));
      }
    },
    initCart() {
      const localCart = localStorage.getItem("guideline-cart");
      this.commit("SET_CART", JSON.parse(localCart ?? "[]"));
      const localTree = localStorage.getItem("guideline-tree");
      this.commit("SET_TREE", JSON.parse(localTree ?? "[]"));
    },
    initFilter() {
      const helper = new CookieHelper();
      const isAdmin = helper.validateTdCookie();
      if (!isAdmin) {
        localStorage.setItem("guideline-filter", JSON.stringify([ResponsibilityType.F, ResponsibilityType.V, ResponsibilityType.Vb]));
      }
      const localFilter = localStorage.getItem("guideline-filter");
      this.commit("SET_FILTER", JSON.parse(localFilter ?? "[]"));
    }
  },

  modules: {

  },
})
